module.exports = __webpack_public_path__ + "img/icon-data.09f9c634.svg";